module.exports = __webpack_public_path__ + "assets/img/hontoyutari-photo02.359c9263.jpg";